import React, { } from "react";
import * as queries from "../../graphql/queries";
import { generateClient } from "aws-amplify/api";
const client = generateClient({
    headers: {
        "x-api-key": "da2-ox6gomta4baghjuzk6hpogw25y",
    },
});
var base64 = require("base-64");

export async function fetchDbSummary({ sites }) {
    try {
        if (!sites?.length) {
            console.log("No sites available");
            return;
        }

        const siteIDs = sites
            .filter((site) => site.status === "Active")
            .map((site) => site.id);

        const result = await client.graphql({
            query: queries.getDBSummary,
            variables: { sitedetailsID: siteIDs },
            authMode: "API_KEY",
        });

        const summary = result.data.getDBSummary;
        return summary;
    } catch (err) {
        console.error("Error fetching DB summary:", err);
        return null;
    }
}
